import { LANGUAGE } from "@/common/utils/constants.js";

export const COMMON_DOCX = {
	[LANGUAGE.en.short]: {
		January: `January`,
		February: `February`,
		March: `March`,
		April: `April`,
		May: `May`,
		June: `June`,
		July: `July`,
		August: `August`,
		September: `September`,
		October: `October`,
		November: `November`,
		December: `December`,
		footerText: `© Akkodis | Digital Reference Catalogue – Client Success Story`
	},
	[LANGUAGE.de.short]: {
		January: `Januar`,
		February: `Februar`,
		March: `März`,
		April: `April`,
		May: `Mai`,
		June: `Juni`,
		July: `Juli`,
		August: `August`,
		September: `September`,
		October: `Oktober`,
		November: `November`,
		December: `Dezember`,
		footerText: `© Akkodis | Digital Reference Catalogue – Kundenerfolgsgeschichte`
	},
	[LANGUAGE.fr.short]: {
		January: `Janvier`,
		February: `Février`,
		March: `Mars`,
		April: `Avril`,
		May: `Mai`,
		June: `Juin`,
		July: `Juillet`,
		August: `Août`,
		September: `Septembre`,
		October: `Octobre`,
		November: `Novembre`,
		December: `Décembre`,
		footerText: `© Akkodis | Digital Reference Catalogue – Témoignage client`
	},
	[LANGUAGE.it.short]: {
		January: `Gennaio`,
		February: `Febbraio`,
		March: `Marzo`,
		April: `Aprile`,
		May: `Maggio`,
		June: `Giugno`,
		July: `Luglio`,
		August: `Agosto`,
		September: `Settembre`,
		October: `Ottobre`,
		November: `Novembre`,
		December: `Dicembre`,
		footerText: `© Akkodis | Digital Reference Catalogue – Storia di successo del cliente`
	},
	[LANGUAGE.ja.short]: {
		January: `1月`,
		February: `2月`,
		March: `行進`,
		April: `4月`,
		May: `5月`,
		June: `六月`,
		July: `7月`,
		August: `8月`,
		September: `9月`,
		October: `10月`,
		November: `11月`,
		December: `12月`,
		footerText: `© Akkodis | Digital Reference Catalogue – クライアントの成功事例`
	},
	[LANGUAGE.es.short]: {
		January: `Enero`,
		February: `Febrero`,
		March: `Marzo`,
		April: `Abril`,
		May: `Mayo`,
		June: `Junio`,
		July: `Julio`,
		August: `Agosto`,
		September: `Septiembre`,
		October: `Octubre`,
		November: `Noviembre`,
		December: `Diciembre`,
		footerText: `© Akkodis | Digital Reference Catalogue – Historia de éxito del cliente`
	}
}
